<template>
  <div class="wrap">
    <!-- 头部信息 -->
    <div class="header">
      <!-- 定位 -->
      <div class="header-left">
        <div>
          <i class="el-icon-location-information"></i>
          {{ areaName }}
        </div>

        <div class="menu">
          <div class="menu-item" @click="goSubject">主体管理</div>
          <div class="menu-item" @click="goMap">主体一张图</div>
        </div>
      </div>

      <!-- 标题 -->
      <div class="header-title">
        {{ appName }}
      </div>

      <!-- 右侧内容 -->
      <div class="header-right">
        <div class="menu">
          <div class="menu-item-nav">
            <el-dropdown @command="handleCommandProject">
              <div class="menu-item-word">项目管理</div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="manger">项目库管理</el-dropdown-item>
                <el-dropdown-item command="gonj">农业生产社会化服务</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-dropdown @command="handleCommandTrade">
            <div class="menu-item-word">产权交易</div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="portal">产权交易门户系统</el-dropdown-item>
              <el-dropdown-item command="manger">产权交易管理系统</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <el-dropdown @command="handleCommand">
          <div class="dropdown-word">
            <i class="el-icon-user-solid"></i>
            {{ username }}
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-remove" command="editpwd">修改密码</el-dropdown-item>
            <el-dropdown-item icon="el-icon-remove" command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>

    <!-- 内容 -->
    <div class="content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </div>

  </div>
</template>
<script>
import Cookies from "js-cookie";
import API_config from "../api/configuration/api_configuration"

export default {
  name: "Dashboard",
  data() {
    return {
      userIcon: "../../static/img/img_tx.jpg",
      isCollapsed: true,
      appName:Cookies.get('appName'),
      username: Cookies.get("accountName"),
      areaCode: Cookies.get("curAreaCode"),
      areaName: Cookies.get("curAreaName"),
      checkList: [],
      headImg:require('../../static/img/logohead.png'),
      //菜单
      menus_1: [],
      activeMenu: [],
      //当前激活的主菜单
      activeIndex: "",
      projectId: "", // 项目名称ID
      projectName: "", // 项目名称ID
      projectList: [{
        number:"",
        name:"全部"
      }],
      projectBak: {
        number:"1",
        name:"其他"
      },
      // showBread: localStorage.getItem('showBread') || false,
      selectedYear: new Date().getFullYear().toString(),
      pickerOptions: {
        disabledDate(time) { return time.getFullYear() > new Date().getFullYear() ;}}
      };
  },
  created() {
    let menus = JSON.parse(localStorage.getItem("menus"));
    this.getSysInfo();
    if (menus) {
      this.menus_1 = menus || [];
      let mainPath = menus[0].menuVoList[0].menuUrl;
      if(this.$route.name!=='home') return
      Cookies.set('mainPath',mainPath);
      this.$nextTick(()=>{
        this.$router.push(mainPath)
      })
    }
  },
  methods: {
    handleCommand(command) {
      if (command == "logout") {
        this.logout();
      }
    },

    // routePath(){
    //   console.log('r', this.$route.path)
    //   if(this.$route.path =='/policy/policyList'){
    //     this.showBread = true
    //   }else if(this.$route.path =='/policy/article'){
    //     this.showBread = true
    //   } else {
    //     this.showBread = false
    //   }
    // },

    getBack(){
      this.$router.back()
    },

    handleCommandTrade(command) {
      if (command == "portal") {
        window.open('http://cqjy.agribigdata.com.cn/shhfw/web/#/')
      } else {
        window.open('http://cqjy.agribigdata.com.cn/shhfw/manage/#/login')
      }
    },

    handleCommandProject(command) {
      if (command == "manger") {
        this.$router.push({ path: "/project/manage" })
      } else {
        this.goSubjectManger()
      }
    },

    goSubject() {
      this.$router.push({ path: "/subject/listOfLibrary" })
    },

    goSubjectManger() {
      window.open('https://nj.agribigdata.com.cn/#/login')
    },

    logout: function () {
      let that = this;
      this.$confirm("是否要注销当前登录" + this.username + "用户?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$router.push({ path: "/login" });
        })
        .catch(() => {});
    },

    // 获取定制化的系统标题
    getSysInfo(){
      API_config.applicationDicDetail({qhdm:this.areaCode}).then(res=>{
        if(res.code===0){
            this.appName= res.data.detail.name
            localStorage.setItem('userSysInfoAppName', res.data.detail.name)
        }
      })
    },

    //菜单开关
    menuCollapse() {
      this.GLOBAL.eventBus.$emit("winSizeChange");
      this.isCollapsed = !this.isCollapsed;
      let that = this;
      if (that.GLOBAL.map) {
        setTimeout(() => {
          that.GLOBAL.map.resize();
        }, 400);
      }
    },

    /*跳转到大屏*/
    goMap() {
      this.$router.push({ path: "/oneMap" });
    },
  },
};
</script>

<style lang="less" scoped>
  .wrap {
    width: 100% !important;
    height: 100% !important;
    // min-width: 1920px !important;
    // min-height: 930px !important;
    background: url("../../static/img/bannerBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .header {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    font-size: 18px;
    margin-bottom: 8px;
    color: #00D7FE;
    background-image: url("../../static/img/topBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: -25px, 0;
  }

  .header-title {
    font-size: 24px;
    font-weight: bold;
    filter: drop-shadow(2px 4px 6px black);
  }

  .header-left, .header-right {
    display: flex;
  }

  .menu {
    display: flex;
    color: #fff;
    // font-size: 20px;
    font-weight: bold;
    margin: 0 16px;
  }

  .menu-item-word {
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
    color: #fff;

    &:hover {
      color: #00D7FE;
    }
  }

  .menu-item {
    cursor: pointer;
    font-weight: bold;
    font-size: 18px;
    color: #fff;

    &:hover {
      color: #00D7FE;
    }

    &:not(:last-child) {
      margin-right: 16px;
    }
  }

  .menu-item-nav {
    margin-right: 12px;
  }

  .dropdown-word {
    font-size: 18px;
    color: #00D7FE;
  }

  .content {
    // 左右16padding
    width: calc(100% - 32px);
    // header 80px
    height: calc(100% - 70px);
    padding: 0 16px;
    color: white;
    overflow-y: auto;
  }
  .el-dropdown-menu__item{
    margin: 5px;
    color: #ffffff!important;
    &:hover{
      background-color: rgba(15, 56, 58,0.31)!important;
    }
    &:focus{
      background-color: rgba(15, 56, 58,0.31)!important;
    }
  }

  .el-dropdown-menu{
    background-color:rgba(8,44,71,0.7) !important;
    color: #95F6FF !important;
    border: none !important;
    .el-dropdown-menu__item{
      color: #95F6FF !important;
    }
    .el-dropdown-menu__item:focus,
    .el-dropdown-menu__item:not(.is-disabled):hover{
      background: rgba(8,44,71,0.3);
      color: #00FFB0 !important;
    }
  }

</style>




// WEBPACK FOOTER //
// src/studio/Dashboard.vue